/**
 * Bank Transactions Routes
 *
 * These routes are children of bank-accounts/:id and inherit the :id param
 */

export default [
    {
        path: 'bank-transfer',
        component: () =>
            import('@/pages/[organisation]/banking/bank-transactions/internal-transfer.vue'),
        name: 'banking.bank-transfer.internal-transfer',
        meta: {
            loginRequired: true,
            permission: 'access.banking.bank-transaction.money-in',
        },
    },
    {
        path: 'money-in',
        component: () =>
            import('@/pages/[organisation]/banking/bank-transactions/money-in.vue'),
        name: 'banking.bank-transactions.money-in',
        meta: {
            loginRequired: true,
            permission: 'access.banking.bank-transaction.money-in',
        },
    },
    {
        path: 'money-out',
        component: () =>
            import('@/pages/[organisation]/banking/bank-transactions/money-out.vue'),
        name: 'banking.bank-transactions.money-out',
        meta: {
            loginRequired: true,
            permission: 'access.banking.bank-transaction.money-in',
        },
    },
    {
        path: 'bank-transactions',
        component: () =>
            import('@/pages/[organisation]/banking/bank-transactions/bank-transactions.vue'),
        name: 'banking.bank-transactions.search-bank-transactions',
        meta: {
            loginRequired: true,
            permission: 'access.banking.bank-transaction.view-bank-transactions',
        },
    },
    {
        path: 'statements/:statementId/auto-reconciliation',
        component: () =>
            import('@/pages/[organisation]/banking/bank-transactions/auto-bank-reconciliation.vue'),
        name: 'banking.bank-transactions.auto-bank-reconciliation',
        meta: {
            loginRequired: true,
            permission: 'access.banking.bank-transaction.view-bank-transactions',
        },
    },
    {
        path: 'outstanding-transactions',
        component: () =>
            import('@/pages/[organisation]/banking/bank-transactions/outstanding-transactions.vue'),
        name: 'banking.bank-transactions.outstanding-transactions',
        meta: {
            loginRequired: true,
            permission: 'access.banking.bank-transaction.view-bank-transactions',
        },
    },
    {
        path: 'bank-transactions/:transactionId',
        component: () =>
            import('@/pages/[organisation]/banking/bank-transactions/bank-transaction/[id].vue'),
        name: 'banking.bank-transactions.view-bank-transaction',
        meta: {
            loginRequired: true,
            permission: 'access.banking.bank-transaction.view-bank-transactions',
        },
    },
    {
        path: 'bank-transactions/:transactionId/deposit-funds',
        component: () =>
            import('@/pages/[organisation]/banking/bank-transactions/deposit-funds.vue'),
        name: 'banking.bank-transactions.deposit-funds',
        meta: {
            loginRequired: true,
            permission: 'access.banking.bank-transaction.deposit-undeposited-fund',
        },
    },
];
